<template>
  <img v-if="isMobileLogo" class="mobile-logo" :src="smexMobileLogo">
  <img v-else class="logo" :src="smexLogo">
</template>
<script>
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'

  export default {
    name: 'smex-logo',
    props: ['isMobileLogo'],
    data() {
      return {
        smexLogo: iconUtil.resolve(misc.SMEX_LOGO),
        smexMobileLogo: iconUtil.resolve(misc.SMEX_MOBILE_LOGO)
      }
    }
  }
</script>

<style scoped>

</style>
